module.exports = __webpack_public_path__ + "img/product-card-03.4376a1f.webp";